"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTINGS_TILING_TYPE = exports.SETTINGS_GRADIENT_DIRECTION = void 0;
exports.SETTINGS_GRADIENT_DIRECTION = ['horizontal', 'vertical'];
exports.SETTINGS_TILING_TYPE = ['bricks', 'grid'];
